import 'flickity/dist/flickity.pkgd'
import vidim from 'vidim/dist/vidim'

const splashSlider = jQuery('.splash__holder'),
    splashSlides = jQuery('.splash__holder .splash')

let splashVideoPrev

if (splashSlider.length > 0 && splashSlides.length > 1) {

    var carousel = splashSlider.flickity({
        cellSelector: '.splash',
        prevNextButtons: false,
        autoPlay: false,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
        pageDots: true,
        cellAlign: 'center',
        // draggable: true,
        arrowShape: {
            x0: 80,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
        }
    })

    // previous
    jQuery('.button--previous').on( 'click', function() {
      carousel.flickity('previous');
    });
    jQuery('.button--previous').on( 'keypress', function(e) {
        if(e.which == 13) {
            carousel.flickity('previous');
            setTimeout(() => {
            const splashSlides = jQuery('.splash__holder .splash')

            splashSlides.each(function( e ) {
                // console.log('it happens?');
                if( !jQuery(this).hasClass('is-selected') ){
                    jQuery(this).find('*').attr('tabindex', '-1')
                }else{
                    jQuery(this).find('.splash__action').attr('tabindex', '0')
                }
            })
        }, 500);
        }
    });
    // next
    jQuery('.button--next').on( 'click', function() {
      carousel.flickity('next');
    });
    jQuery('.button--next').on( 'keypress', function(e) {
        if(e.which == 13) {
            carousel.flickity('next');
            setTimeout(() => {
            const splashSlides = jQuery('.splash__holder .splash')
            splashSlides.each(function( e ) {
                if( !jQuery(this).hasClass('is-selected') ){
                    jQuery(this).find('*').attr('tabindex', '-1')
                }else{
                    jQuery(this).find('.splash__action').attr('tabindex', '0')
                }
            })
            }, 500);
        }
    });





}

jQuery(document).ready(function() {

    function updateCounter(index) {
        // Hide all counters
        jQuery('.splash__count').removeClass('is-selected');

        // Show the counter with the corresponding index
        jQuery('.splash__count').eq(index).addClass('is-selected');
    }

    if (splashSlider.length > 0 && splashSlides.length > 1) {
        carousel.on('change.flickity', function(event, index) {
            updateCounter(index);
        });

        // Initial counter update on page load
        var initialIndex = carousel.data('flickity').selectedIndex;
        updateCounter(initialIndex);
    }
})
